
import {
  useQuery,
  UseQueryOptions,
} from 'react-query';
import axios, { AxiosError } from 'axios';
import { DefaultGetResponse } from '~/App/Api/rest';

export const fallbackUsageApiPath = '/api/v3/billing/subscriptions/usage-based';

export const queryKeys = {
  all: ['fallback-usage'],
  details: () => [...queryKeys.all, 'detail'] as const,
  detail: (uuid: string) => [...queryKeys.details(), uuid] as const,
};

export interface FallbackUsageAmount {
  amount: number;
  currency: string;
}

export interface FallbackUsageFeeCharge extends FallbackUsageAmount{
  name: string;
  invoicing_interval: string | null;
  type: string;
  amount_minimum_spend: number | null;
  minimum_billable_usage: number | null;
  mode: string;
}

export interface FallbackUsageFeeMetric {
  id: string;
  event_name: string;
  aggregation: string;
  type: string;
}

export interface FallbackUsageFee {
  amount: number;
  description?: string | null;
  usage: number;
  charge: FallbackUsageFeeCharge;
  metric: FallbackUsageFeeMetric;
}

export interface FallbackUsage extends FallbackUsageAmount {
  period_start_at: string;
  period_end_at: string;
  fees: FallbackUsageFee[];
}

export async function fetchFallbackUsage() {
  const res = await axios.get<FallbackUsage>(fallbackUsageApiPath);
  return res.data;
}


export interface UseFallbackUsageHookParams {
  queryOptions?: UseQueryOptions<DefaultGetResponse<FallbackUsage>, AxiosError>;
}

export const useFallbackUsage = (params?: UseFallbackUsageHookParams) =>
  useQuery<DefaultGetResponse<FallbackUsage>, AxiosError>(
    queryKeys.all,
    fetchFallbackUsage,
    {
      refetchOnWindowFocus: false,
      ...params?.queryOptions,
    }
  );